export default __webpack_public_path__ + "static/media/double-check.afc971a6.svg";